import {
  TransactionConnectionType,
  TransactionEventStatus,
  TransactionMethod,
  TransactionStatus,
  TransactionType,
} from "../../transactions";
import { schemes, zSchema } from "../../schema-validation";

const instrumentSchema = zSchema.object({
  bankAccountID: zSchema.string().nullish(),
  last_four: zSchema.string().nullish(),
  paycardID: zSchema.string().nullish(),
  card_details: zSchema.record(zSchema.string(), zSchema.unknown()).nullish(),
  wire_details: zSchema.record(zSchema.string(), zSchema.unknown()).nullish(),
});

export const returnedTransactionWebhookSchema = zSchema.object({
  test: zSchema.boolean(),
  transactionID: schemes.uuid(),
  amount: zSchema.number(),
  status: zSchema.literal(TransactionStatus.Returned),
  method: zSchema.nativeEnum(TransactionMethod),
  source_instrument: instrumentSchema,
  destination_instrument: instrumentSchema.omit({
    wire_details: true,
  }),
  transaction_type: zSchema.nativeEnum(TransactionType),
  connection_type: zSchema.nativeEnum(TransactionConnectionType).nullish(),
  connectionID: zSchema.string().nullish(),
  traceID: zSchema.string().nullish(),
  retry: zSchema.boolean().default(false),
  transaction_events: zSchema.array(
    zSchema.object({
      transactionEventID: schemes.uuid(),
      timestamp: zSchema.string(),
      status: zSchema.nativeEnum(TransactionEventStatus),
      return_code: zSchema.string().nullish(),
      status_detail: zSchema.string().nullish(),
    })
  ),
});

export type TReturnedTransactionWebhookPayload = zSchema.infer<
  typeof returnedTransactionWebhookSchema
>;
